import React, { useEffect, useState } from "react";
import { MdCheck } from "react-icons/md";
import { BASE_URL_IMG } from "src/api.config";
import { cn } from "src/lib/utils";

interface SecondImageCardOptionProps {
  option: any;
  selectedOption: any;
  handleStepForward: (args: any) => void;
  options: any;
  setOptionSelected: any;
}

const SecondImageCardOption: React.FC<SecondImageCardOptionProps> = ({
  option,
  options,
  selectedOption,
  handleStepForward,
  setOptionSelected,
}) => {
  const [animationFlicker, setAnimationFlicker] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = `${BASE_URL_IMG}${option.img_path}`;
    img.onload = () => console.log("Image preloaded");
    img.onerror = () => console.log("Failed to preload iamge");
  }, [option.img_path]);

  // const getImage = async () => {
  //   const response = await fetch(`${BASE_URL_IMG}${option.img_path}`);
  //   return response;
  // };
  // const image = getImage();

  // if (!image) return null;
  return (
    <li
      className={cn(
        `outline-none border flex flex-col text-lg hover:bg-[#FBCE37]/40 transition  py-2 my-4 cursor-pointer rounded relative items-center justify-between w-full ${
          selectedOption.value.id === option.id ? "border-2" : ""
        }`,
        animationFlicker &&
          selectedOption.value.id === option.id &&
          "animate-flicker"
      )}
      key={option.id}
      onClick={() => {
        selectedOption.onChange(option);

        setOptionSelected(option);
        setAnimationFlicker(true);
        setTimeout(() => {
          handleStepForward(option);
          setAnimationFlicker(false);
        }, 700);
      }}
    >
      <img src={`${BASE_URL_IMG}${option.img_path}`} alt={`${option.id}`} />
      <p className="flex items-center space-x-2 my-2">
        <div
          className={cn(
            "border h-6 w-6 bg-black/80 flex items-center justify-center rounded-full border-[#FBCE37] text-[#FBCE37] text-[15px]",
            selectedOption.value.id === option.id &&
              "bg-[#FBCE37] text-black/80"
          )}
        >
          {options.indexOf(option) + 1}
        </div>
        <p>{option.option_text}</p>
      </p>
      {selectedOption.value.id === option.id && (
        <div className="absolute -top-[2px] -right-[2px] triangle">
          <MdCheck className="h-6 w-6 text-black ml-7 mt-1" />
        </div>
      )}
    </li>
  );
};

export default SecondImageCardOption;
